// actions
import {
  SET_SEARCH_QUERY,
  SET_SELECTED_RESULT,
  SET_SELECTED_INPUT,
  SET_AUTOCOMPLETE_RESULTS,
} from '../constants/types';

// import { updateSearchLocationDetails } from '../actions/search';

const initialState = {
  selectedSearchResult: null,
  selectedInput: {},
  searchResults: [],
  userInput: '',
  editing: true,
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_QUERY:
      return {
        ...state,
        userInput: action.userInput,
      };
    case SET_SELECTED_RESULT:
      return {
        ...state,
        selectedSearchResult: action.selectedSearchResult,
      };
    case SET_SELECTED_INPUT:
      return {
        ...state,
        selectedInput: action.selectedInput,
      };
    case SET_AUTOCOMPLETE_RESULTS:
      return {
        ...state,
        searchResults: action.searchResults,
      };
    default:
      return state;
  }
};

export default searchReducer;
